import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const CookieNotice = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged
    const acknowledged = localStorage.getItem('cookie_notice_acknowledged');
    if (!acknowledged) {
      // Show after 2 seconds
      setTimeout(() => setIsVisible(true), 2000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_notice_acknowledged', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 p-4 bg-white/95 backdrop-blur-lg border-t border-slate-200 shadow-lg animate-fade-in-up">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4 flex-wrap">
        <div className="flex-1 min-w-[300px]">
          <p className="text-sm text-slate-700 leading-relaxed">
            Diese Website nutzt ein Kontaktformular sowie einen optionalen KI-Chatbot. Eingaben im Chatbot werden an OpenAI (USA) übermittelt.
            Weitere Informationen finden Sie in unserer{' '}
            <Link
              to="/datenschutz"
              className="text-slate-900 underline hover:text-slate-600 font-medium"
              data-testid="cookie-datenschutz-link"
            >
              Datenschutzerklärung
            </Link>.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Button
            onClick={handleAccept}
            className="bg-slate-800 hover:bg-slate-700 text-white text-sm px-6"
          >
            Verstanden
          </Button>
          <button
            onClick={handleAccept}
            className="text-slate-500 hover:text-slate-700 transition-colors"
            aria-label="Schließen"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieNotice;